<template>
    <div class="p-5">
        <div class="mb-5">
            <h4 class="mb-3">Objet de l'email de remerciement</h4>
            <v-text-field
              outlined
              v-model="configEmailObject"
              hide-details
            ></v-text-field>
        </div>

        <div class="mb-5">
            <h4 class="mb-3">Première partie de l'e-mail</h4>
            <ckeditor
              :editor="editor"
              v-model="configEmailPart1"
            ></ckeditor>
        </div>

        <div class="text-center valid-button mt-3">
            <adh-summary-example></adh-summary-example>
        </div>

        <div class="mb-5">
            <h4 class="mb-3">Dernière partie de l'e-mail</h4>
            <ckeditor
              :editor="editor"
              v-model="configEmailPart2"
            ></ckeditor>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"
import ClassicEditor from "../../../../plugins/ckeditor"
import AdhSummaryExample from "../../../configuration/AdhSummaryExample.vue"

export default {
    name: "CadhEmail",
    components: { AdhSummaryExample },
    data() {
        return {
            editor: ClassicEditor,
            canWatch: false,
        }
    },
    methods: {
        ...mapMutations("cadhConfig", ["setParameterCurrentStep", "setEmailObject", "setEmailPart1", "setEmailPart2"]),
        updateEmailObject() {
            let payload = {
                "configId": this.cadhConfig.id,
                "key": "email_remerciement_subject",
                "value": this.emailObject,
            }

            this.updateKey(payload)
        },
        updateEmailPart1() {
            let payload = {
                "configId": this.cadhConfig.id,
                "key": "email_remerciement_part_1",
                "value": this.emailPart1,
            }

            this.updateKey(payload)
        },
        updateEmailPart2() {
            let payload = {
                "configId": this.cadhConfig.id,
                "key": "email_remerciement_part_2",
                "value": this.emailPart2,
            }

            this.updateKey(payload)
        },
        updateKey(payload) {
            this.$global.loading = true

            this.$store.dispatch("cadhConfig/updateConfigurationKey", payload)

            this.$global.loading = false
        },
    },
    computed: {
        ...mapState("cadhConfig", ["cadhConfig", "parameterCurrentStep", "emailObject", "emailPart1", "emailPart2", "dataLoaded"]),
        configEmailObject: {
            get() {
                if (this.emailObject) {
                    return this.emailObject
                } else {
                    return ""
                }
            },
            set(value) {
                this.setEmailObject(value)
            },
        },
        configEmailPart1: {
            get() {
                if (this.emailPart1) {
                    return this.emailPart1
                } else {
                    return ""
                }
            },
            set(value) {
                this.setEmailPart1(value)
            },
        },
        configEmailPart2: {
            get() {
                if (this.emailPart2) {
                    return this.emailPart2
                } else {
                    return ""
                }
            },
            set(value) {
                this.setEmailPart2(value)
            },
        },
    },
    watch: {
        emailObject() {
            if (this.canWatch) {
                this.updateEmailObject()
            }
        },
        emailPart1() {
            if (this.canWatch) {
                this.updateEmailPart1()
            }
        },
        emailPart2() {
            if (this.canWatch) {
                this.updateEmailPart2()
            }
        },
    },
    updated() {
        this.canWatch = true
    },
}
</script>